import type { DocumentModel } from "@bindery/shared/corpus/document";
import {
  colocationForModel,
  getOptions,
} from "@bindery/shared/reader/confounders";
import { spanTokenCount } from "@bindery/convex-retells/model/selection";
import { foldQuote } from "@bindery/convex-retells/model/wordGloss";
import type { ReferenceSelection } from "./reference-lookup";

export function referenceSelection(
  model: DocumentModel,
  start: number,
  end: number,
  language: string,
): ReferenceSelection | null {
  if (
    !Number.isInteger(start) ||
    !Number.isInteger(end) ||
    start < 0 ||
    end > model.text.length ||
    start >= end
  )
    return null;

  const text = model.text.slice(start, end);
  if (text.trim().length === 0) return null;
  const singleWord = spanTokenCount(model, start, end) === 1;
  return {
    text,
    language,
    singleWord,
    confounders: singleWord
      ? getOptions(foldQuote(text), colocationForModel(model, foldQuote))
      : [],
    context:
      model.contextLinks.find(
        (link) => link.start === start && link.end === end,
      ) ?? null,
  };
}
